export default __webpack_public_path__ + "static/media/sidebar-cbp-dark-disabled.c620b880.svg";